import {
  Card,
  CardHeader,
  Grid,
  Paper,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableRow,
  ThemeProvider,
  createTheme,
} from "@material-ui/core";
import * as locales from "@material-ui/core/locale";
import RowAppEmployee from "./row-app-employees-task";
import Scrollbar from "../Scrollbar";
import { TablaHead, TablaToolbar } from "../_dashboard/tablas";
import { useMemo, useState } from "react";
import SearchNotFound from "../SearchNotFound";
import { applySortFilter, getComparator } from "src/utils/sharedTables";
import CustomTablePagination from "../CustomTablePagination";
import PropTypes from "prop-types";

AppEmployeesTask.propTypes = {
  rows: PropTypes.array,
  title: PropTypes.string,
  subheader: PropTypes.string,
  loading: PropTypes.bool,
};

export default function AppEmployeesTask({
  rows,
  title,
  subheader,
  loading = false,
}) {
  const [state, setState] = useState(INITIAL_STATE_TABLE);

  const handleFilterByName = (event) => {
    setState({ ...state, filterName: event.target.value });
  };

  const handleRequestSort = (event, property) => {
    const isAsc = state.orderBy === property && state.order === "asc";
    setState({ ...state, order: isAsc ? "desc" : "asc", orderBy: property });
  };

  const emptyRows =
    state.currentPage > 0
      ? Math.max(
          0,
          (1 + state.currentPage) * state.rowsPerPageOptions - rows.length,
        )
      : 0;

  const filasFiltradas = useMemo(() => {
    const propiedadesParaFiltrar = [
      "nameEmployee",
      "task",
      "nameClient",
      "branch",
      "taskType",
      "state",
    ];
    return applySortFilter(
      rows,
      getComparator(state.order, state.orderBy),
      state.filterName,
      propiedadesParaFiltrar,
    );
  }, [rows, state.filterName, state.order, state.orderBy]);

  const esSucursalNoEncontrada = filasFiltradas.length === 0;

  const handleChangePage = (event, newPage) => {
    setState({ ...state, currentPage: newPage });
  };

  const handleChangeRowsPerPage = (event) => {
    setState({
      ...state,
      rowsPerPageOptions: Number(event.target.value),
      currentPage: 0,
    });
  };

  return (
    <Card sx={{ height: "100%" }}>
      <Grid
        container
        direction="column"
        justifyContent="flex-start"
        alignItems="stretch"
        sx={{ height: "100%" }}
      >
        <Grid item>
          <Grid container>
            <Grid item xs={12} md={6} lg={6}>
              <CardHeader title={title} subheader={subheader} />
            </Grid>
            <Grid item xs={12} md={6} lg={6}>
              <Grid container justifyContent="flex-end" alignItems="center">
                <Grid item></Grid>
                <Grid
                  item
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                  }}
                  xs={12}
                  md={8}
                  lg={8}
                >
                  <TablaToolbar
                    filterName={state.filterName}
                    onFilterName={handleFilterByName}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <Scrollbar sx={{ height: "100%" }}>
            <TableContainer component={Paper}>
              {!loading ? (
                <Table aria-label="collapsible table">
                  <TablaHead
                    order={state.order}
                    orderBy={state.orderBy}
                    headLabel={TABLE_HEAD}
                    rowCount={rows?.length}
                    onRequestSort={handleRequestSort}
                  />
                  <TableBody>
                    {filasFiltradas
                      .slice(
                        state.currentPage * state.rowsPerPageOptions,
                        state.currentPage * state.rowsPerPageOptions +
                          state.rowsPerPageOptions,
                      )
                      .map((row, index) => (
                        <RowAppEmployee key={index} row={row} />
                      ))}
                    {emptyRows > 0 && (
                      <TableRow style={{ height: 53 * emptyRows }}>
                        <TableCell colSpan={7} />
                      </TableRow>
                    )}
                  </TableBody>
                  {esSucursalNoEncontrada && (
                    <TableBody>
                      <TableRow>
                        <TableCell align="center" colSpan={9} sx={{ py: 3 }}>
                          <SearchNotFound searchQuery={state.filterName} />
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                  <TableFooter>
                    <TableRow>
                      <ThemeProvider
                        theme={(outerTheme) =>
                          createTheme(outerTheme, locales[state.locale])
                        }
                      >
                        <CustomTablePagination
                          count={filasFiltradas.length}
                          rowsPerPage={state.rowsPerPageOptions}
                          page={state.currentPage}
                          colSpan={9}
                          onPageChange={handleChangePage}
                          onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                      </ThemeProvider>
                    </TableRow>
                  </TableFooter>
                </Table>
              ) : (
                <Skeleton variant="rectangular" width="100%" height="500px" />
              )}
            </TableContainer>
          </Scrollbar>
        </Grid>
      </Grid>
    </Card>
  );
}

const TABLE_HEAD = [
  { id: "action", label: "", alignRight: false },
  { id: "empleado", label: "Empleado", alignRight: false },
  { id: "tarea", label: "Tarea", alignRight: false },
  { id: "cliente", label: "Cliente", alignRight: false },
  { id: "sucursal", label: "Sucursal", alignRight: false },
  { id: "tipo-tarea", label: "Tipo tarea", alignRight: true },
  { id: "estado", label: "Estado", alignRight: true },
  { id: "fecha", label: "Fecha", alignRight: true },
  { id: "creada", label: "Creada", alignRight: true },
  { id: "ver-tarea", label: "", alignRight: true },
];

const INITIAL_STATE_TABLE = {
  currentPage: 0,
  rowsPerPageOptions: 5,
  order: "asc",
  orderBy: "",
  locale: "esES",
  filterName: "",
};
